import { useDeviceSize } from '@facephi/ui-react';
import { yupResolver } from '@hookform/resolvers/yup';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDeviceSize as useDeviceDimensions } from '../../hooks';
import { useAuth, useConfig } from '../../providers';
import { UserInfoDto, userInfoSchema, RoutesName } from '../../states';
import { GoBackButton } from './GoBackButton';
import {
  Card,
  CardContainer,
  FrontFace,
  ButtonLogin,
  InputLogin,
  LoginCard,
  LoginForm,
  LogoLogin,
  LoginMessage,
} from './Styles';

export const UserInfoCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { isMobile } = useDeviceSize();
  const { deviceHeight } = useDeviceDimensions();
  const { setUserName, setUserLastname, setUserInfoCompleted } = useConfig();
  const isSmallScreen = deviceHeight <= 705;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(userInfoSchema),
  });

  const onSubmit: SubmitHandler<UserInfoDto> = async (data: UserInfoDto) => {
    setUserName(data.userName);
    setUserLastname(data.userLastName);
    setUserInfoCompleted(true);
    navigate(RoutesName.home);
  };

  return (
    <CardContainer>
      <Card $smallScreen={isSmallScreen}>
        <FrontFace>
          {!isMobile && (
            <GoBackButton
              iconSize="24"
              iconName="CaretLeft"
              iconColor="blue400"
              labelText={t('Go back')}
              onClick={logout}
              testId="goBack-logout"
            />
          )}
          <LoginCard>
            <LogoLogin
              logoApp="Authentication"
              size="56"
              color="dark"
              labelLines="2"
            />
            <LoginForm
              forwardedAs="form"
              flexDirection="column"
              justifyContent="center"
              onSubmit={handleSubmit(onSubmit)}
            >
              <LoginMessage textAlign="center" size={14} color="grey500">
                {t('We want to offer you a personalised experience')}
              </LoginMessage>

              <LoginMessage textAlign="left" size={16} color="grey700" semibold>
                {t('Enter your name and surname')}
              </LoginMessage>
              <InputLogin
                testId="user-info-name"
                type="text"
                label={t('Name') as string}
                {...register('userName')}
                placeholder={t('Name') as string}
                errorLabel={errors.userName && t(errors.userName.message)}
              />
              <InputLogin
                testId="user-info-lastName"
                type="text"
                {...register('userLastName')}
                label={t('Last name') as string}
                placeholder={t('Last name') as string}
                errorLabel={
                  errors.userLastName && t(errors.userLastName.message)
                }
              />

              <ButtonLogin
                size="L"
                type="submit"
                color="primary"
                testId="userInfo-continue-bttn"
              >
                {t('Continue').toLocaleUpperCase()}
              </ButtonLogin>
            </LoginForm>
          </LoginCard>
        </FrontFace>
      </Card>
    </CardContainer>
  );
};
